<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang_].title : ''">
        <template #body>
            <div class="flex flex-row mb-3 mt-2 xl:mb-6">
                <div class="flex flex-column flex-1 pr-1 xl:pr-2">
                    <span class="flex text-3xl xl:text-6xl font-semibold text-800 mb-2">
                        <span v-if="stat.transfers">{{ stat.transfers }}</span>
                        <Skeleton v-else height="2rem"/>
                    </span>
                    <span class="flex text-sm xl:text-lg text-500 mr-2 mt-1 xl:mt-2">
                        {{ lang.total_transfers[lang_] }}
                    </span>
                </div>
                <div class="flex flex-column flex-1 pr-1 xl:pr-2">
                    <span class="flex text-3xl xl:text-6xl font-semibold text-800 mb-2">
                        <span v-if="stat.reviews">{{ stat.reviews }}</span>
                        <Skeleton v-else height="2rem"/>
                    </span>
                    <span class="flex text-sm xl:text-lg text-500 mr-2 mt-1 xl:mt-2">
                        {{ lang.total_reviews[lang_] }}
                    </span>
                </div>
                <div class="flex flex-column flex-1 pr-1 xl:pr-2">
                    <span class="flex text-3xl xl:text-6xl font-semibold text-800 mb-2">
                        <span v-if="stat.time">{{ stat.time }}</span>
                        <Skeleton v-else height="2rem"/>
                    </span>
                    <span class="flex text-sm xl:text-lg text-500 mr-2 mt-1 xl:mt-2">
                        {{ lang.average_transfer_time[lang_] }}
                    </span>
                </div>
                <div class="flex flex-column flex-1 pr-1 xl:pr-2">
                    <span class="flex text-3xl xl:text-6xl font-semibold text-800 mb-2">
                        <span v-if="stat.percent">{{ stat.percent }}</span>
                        <Skeleton v-else height="2rem"/>
                    </span>
                    <div v-if="stat.percent" class="bg-yellow-300 w-full" style="height:3px;">
                        <div class="bg-green-100" style="height:3px;" :style="`width:${stat.percent};`"></div>
                    </div>
                    <span class="flex text-sm xl:text-lg text-500 mr-2 mt-1 xl:mt-2">
                        {{ lang.positive_ratings[lang_] }}
                    </span>
                </div>
            </div>

            <div v-if="reviews" class="flex flex-row gap-3">
                <Select v-model="sorded" :options="sort_list[lang_]" optionLabel="name" :placeholder="lang.sort_by[lang_]" 
                    class="w-full mb-3 border-round-lg xl:max-w-15rem lg:max-w-15rem md:max-w-15rem sm:max-w-15rem">
                    <template #dropdownicon>
                        <i class="pi pi-sort-alt" />
                    </template>
                </Select>

                <Select v-model="filter" :options="filters[lang_]" optionLabel="name" :placeholder="lang.sort_by[lang_]" 
                    class="w-full mb-3 border-round-lg xl:max-w-15rem lg:max-w-15rem md:max-w-15rem sm:max-w-15rem">
                    <template #dropdownicon>
                        <i class="pi pi-filter" />
                    </template>
                </Select>
            </div>
            <Skeleton v-else height="2rem" class="mb-2"/>

            <div v-if="reviews && reviews.length>0" class="flex flex-column w-full max-w-30rem">
                <div v-for="r in reviews" class="flex flex-column relative surface-100 p-3
                    border-round-xl xl:border-round-2xl 
                    mb-2 xl:mb-3
                    gap-2 xl:gap-0">
                    <Review :review="r" :bank_list="bank_list" :payment_systems="payment_systems" />
                </div>
            
                <Paginator v-if="stat && reviews" :rows="10" v-model:first="skip" :totalRecords="stat.reviews" ></Paginator>
            </div>

            <div v-if="loading" class="w-full flex gap-3">
                <Skeleton height="6rem" class="flex border-round-xl"/>
                <Skeleton height="6rem" class="flex border-round-xl"/>
                <Skeleton height="6rem" class="flex border-round-xl"/>
            </div>
        </template>
    </Page>
</template>


<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Page from '@/components/sides/Page.vue'
import Review from '@/components/widgets/Review.vue'
import AddReview from '@/components/widgets/transfer/AddReview.vue'
import { mapActions }   from 'vuex'
import { BankList, PaymentSystemList } from '@/assets/js/classes/PaymentSystem.js'

export default {
    data() {
        return {
            header: {
                en: {title: "Reviews"} ,
                ru: {title: "Отзывы"} ,
            }, 
            sorded: { name: 'Последние', code: 'date_last' },
            sort_list: {
                ru:  [
                    { name: 'Последние', code: 'date_last' },
                    { name: 'Первые', code: 'date_first' },
                    { name: 'Положительные', code: 'good' },
                    { name: 'Отрицательные', code: 'bad' },
                ],
                    en:  [
                    { name: 'Last', code: 'date_last' },
                    { name: 'First', code: 'date_first' },
                    { name: 'Positive', code: 'good' },
                    { name: 'Negative', code: 'bad' },
                ]
            },
            filter: { name: 'Все', code: 'all' },
            filters: {
               ru: [
                    { name: 'Все', code: 'all' },
                    { name: 'Публичные', code: 'public' },
                    { name: 'Анонимные', code: 'anonymous' },
                ],
                en: [
                    { name: 'All', code: 'all' },
                    { name: 'Public', code: 'public' },
                    { name: 'Anonymous', code: 'anonymous' },
               ]
            },
            stat: {
                transfers: null,
                reviews: null,
                time: null,
                percent: null,
            },
            skip: 0,
            reviews: [],
            loading: false,
            bank_list: [],
            payment_systems: [],
            lang: {
                total_transfers: {
                    en: 'Total transfers',
                    ru: 'Всего переводов',
                },
                total_reviews: {
                    en: 'Total reviews',
                    ru: 'Всего отзывов',
                },
                average_transfer_time: {
                    en: 'Average transfer time',
                    ru: 'Среднее время перевода в минутах',
                },
                positive_ratings: {
                    en: 'Positive ratings',
                    ru: 'Положительных оценок',
                },
                sort_by: {
                    en: 'Sort by',
                    ru: 'Сортировать по',
                },
            }
        }
    },
    components: {
        Page,
        Review,
        AddReview
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        async GetReviews(){
            this.loading = true
            try {
                this.reviews = []
                let filter = {}
                if(this.filter.code=='public'){
                    filter = {public: true}
                } else if(this.filter.code=='anonymous'){
                    filter = {public: false}
                }
                const reviews = await this.connect.get_reviews({limit: 10, skip: this.skip, sort: this.sorded.code, filter: filter}).then(res=>res)
                if(reviews.result && reviews.data) this.reviews = reviews.data
            } catch {
                this.loading = false
                this.showMess('error', this.content[this.lang_].msg_error_title, this.content[this.lang_].msg_error_text)
            }
            try{ window.scrollTo({ top: 0, behavior: 'smooth' }) } catch {}
            this.loading = false
        },
        async GetStat(){
            try {
                const stat = await this.connect.get_reviews_stat().then(res=>res)
                if(stat.result){
                    const percent = Math.round((stat.data.good / stat.data.reviews) * 100)
                    this.stat = {
                        transfers: stat.data.transfers,
                        reviews: stat.data.reviews,
                        time: '5',
                        percent: `${percent}%`,
                    }
                }
            } catch {}
        },
        async LoadBankList(){
            this.bank_list = await BankList.GetList(this.$store).then(r=>r)
            if(!this.bank_list || !this.bank_list.length) this.bank_list = []
        },
        async LoadPaymentSystems(){
            this.payment_systems = await PaymentSystemList.GetList(this.$store).then(r=>r)
            if(!this.payment_systems || !this.payment_systems.length) this.payment_systems = []
        },
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    watch: {
        async skip() {
            this.GetReviews().then(()=>{})
        },
        async sorded() {
            this.GetReviews().then(()=>{})
        },
        async filter() {
            this.GetReviews().then(()=>{})
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted() {
        this.GetStat().then()
        this.GetReviews().then(()=>{})
        this.LoadBankList().then(()=>{})
        this.LoadPaymentSystems().then(()=>{})

        try {
            this.SetHeaderTitle(this.header[this.lang_].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>